import React, { useState, useRef, useEffect, useContext } from "react";

import { useHistory } from "react-router-dom";
import { format, isSameDay, parseISO } from "date-fns";
// import { SocketContext } from "../../context/Socket/SocketContext";

import useSound from "use-sound";

import { MdChatBubbleOutline, MdPerson } from "react-icons/md";

import useTickets from "../../hooks/useTickets";
import alertSound from "../../assets/sound.mp3";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import Favicon from "react-favicon";
import defaultLogoFavicon from "../../assets/favicon.ico";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import ColorModeContext from "../../layout/themeContext";

const NotificationsPopOver = (volume) => {
	const { appName } = useContext(ColorModeContext);

	const history = useHistory();
	// const socketManager = useContext(SocketContext);
	const { user, socket } = useContext(AuthContext);
	const { profile, queues } = user;

	const ticketIdUrl = +history.location.pathname.split("/")[2];
	const ticketIdRef = useRef(ticketIdUrl);
	const dropdownRef = useRef();
	const [isOpen, setIsOpen] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const { get: getSetting } = useCompanySettings();
	const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);

	const [showTicketWithoutQueue, setShowTicketWithoutQueue] = useState(false);
	const [showNotificationPending, setShowNotificationPending] = useState(false);
	const [showGroupNotification, setShowGroupNotification] = useState(false);

	const [, setDesktopNotifications] = useState([]);

	const { tickets } = useTickets({
		withUnreadMessages: "true"
		// showAll: showTicketWithoutQueue ? "true" : "false"
	});

	const [play] = useSound(alertSound, volume);
	const soundAlertRef = useRef();

	const historyRef = useRef(history);

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const setting = await getSetting(
					{
						"column": "showNotificationPending"
					}
				);



				if (setting.showNotificationPending === true) {
					setShowNotificationPending(true);
				}

				if (user.allTicket === "enable") {
					setShowTicketWithoutQueue(true);
				}
				if (user.allowGroup === true) {
					setShowGroupNotification(true);
				}
			} catch (err) {
				toastError(err);
			}
		}

		fetchSettings();
	}, [setShowTicketWithoutQueue, setShowNotificationPending]);

	useEffect(() => {
		soundAlertRef.current = play;

		if (!("Notification" in window)) {
			console.log("This browser doesn't support notifications");
		} else {
			Notification.requestPermission();
		}
	}, [play]);

	useEffect(() => {
		const processNotifications = () => {
			// if (showTicketWithoutQueue) {
			setNotifications(tickets);
			// } else {
			// 	const newNotifications = tickets.filter(ticket => ticket.status !== "pending");

			// 	setNotifications(newNotifications);
			// }
		}

		processNotifications();
	}, [tickets]);

	useEffect(() => {
		ticketIdRef.current = ticketIdUrl;
	}, [ticketIdUrl]);

	useEffect(() => {
		const companyId = user.companyId;
		// const socket = socketManager.GetSocket();
		if (user.id && socket) {
			const onConnectNotificationsPopover = () => {
				socket.emit("joinNotification");
			}

			const onCompanyTicketNotificationsPopover = (data) => {
				if (data.action === "updateUnread" || data.action === "delete") {
					setNotifications(prevState => {
						const ticketIndex = prevState.findIndex(t => t.id === data.ticketId);
						if (ticketIndex !== -1) {
							prevState.splice(ticketIndex, 1);
							return [...prevState];
						}
						return prevState;
					});

					setDesktopNotifications(prevState => {
						const notfiticationIndex = prevState.findIndex(
							n => n.tag === String(data.ticketId)
						);
						if (notfiticationIndex !== -1) {
							prevState[notfiticationIndex].close();
							prevState.splice(notfiticationIndex, 1);
							return [...prevState];
						}
						return prevState;
					});
				}
			};

// Adicione esta lógica no componente NotificationsPopOver
const onCompanyAppMessageNotificationsPopover = (data) => {
    if (
        data.action === "create" && !data.message.fromMe &&
        !data.message.read &&
        (data.ticket?.userId === user?.id || !data.ticket?.userId) &&
        (user?.queues?.some(queue => (queue.id === data.ticket.queueId)) ||
            !data.ticket.queueId && showTicketWithoutQueue === true) &&
        (!["pending", "lgpd", "nps", "group"].includes(data.ticket?.status) ||
            (data.ticket?.status === "pending" && showNotificationPending === true) ||
            (data.ticket?.status === "group" && data.ticket?.whatsapp?.groupAsTicket === "enabled" && showGroupNotification === true))
    ) {
        // Aplicar lógica de permissão para mensagens pending
        const shouldBlurMessages = data.ticket.status === "pending" && user.allowSeeMessagesInPendingTickets === "disabled";
        
        // Se deve ocultar a mensagem, modifique o ticket antes de adicioná-lo às notificações
        const ticketToAdd = shouldBlurMessages 
            ? {
                ...data.ticket,
                lastMessage: i18n.t("notifications.messageHidden") // ou "Mensagem oculta"
              }
            : data.ticket;

        setNotifications(prevState => {
            const ticketIndex = prevState.findIndex(t => t.id === ticketToAdd.id);
            if (ticketIndex !== -1) {
                prevState[ticketIndex] = ticketToAdd;
                return [...prevState];
            }
            return [ticketToAdd, ...prevState];
        });

        const shouldNotNotificate =
            (data.message.ticketId === ticketIdRef.current &&
                document.visibilityState === "visible") ||
            (data.ticket.userId && data.ticket.userId !== user?.id) ||
            (data.ticket.isGroup && data.ticket?.whatsapp?.groupAsTicket === "disabled" && showGroupNotification === false);

        if (shouldNotNotificate === true) return;

        // Para notificações desktop, também aplicar a lógica de ocultação
        const messageBody = shouldBlurMessages 
            ? i18n.t("notifications.messageHidden")
            : data.message.body;

        handleNotifications({
            ...data,
            message: {
                ...data.message,
                body: messageBody
            }
        });
    }
}

			socket.on("connect", onConnectNotificationsPopover);
			socket.on(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
			socket.on(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);

			return () => {
				socket.off("connect", onConnectNotificationsPopover);
				socket.off(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
				socket.off(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);
			};
		}
		return undefined;
	}, [user, profile, queues, showTicketWithoutQueue, socket, showNotificationPending, showGroupNotification]);

	const handleNotifications = data => {
		const { message, contact, ticket } = data;

		const options = {
			body: `${message.body} - ${format(new Date(), "HH:mm")}`,
			icon: contact.urlPicture,
			tag: ticket.id,
			renotify: true,
		};
		const notification = new Notification(
			`${i18n.t("tickets.notification.message")} ${contact.name}`,
			options
		);

		notification.onclick = e => {
			e.preventDefault();
			window.focus();
			setTabOpen(ticket.status)
			historyRef.current.push(`/tickets/${ticket.uuid}`);
			// handleChangeTab(null, ticket.isGroup? "group" : "open");
		};

		setDesktopNotifications(prevState => {
			const notfiticationIndex = prevState.findIndex(
				n => n.tag === notification.tag
			);
			if (notfiticationIndex !== -1) {
				prevState[notfiticationIndex] = notification;
				return [...prevState];
			}
			return [notification, ...prevState];
		});
		soundAlertRef.current();
	};

	const handleClick = () => {
		setIsOpen(prevState => !prevState);
	};

	const handleClickAway = () => {
		setIsOpen(false);
	};

	useEffect(() => {
		if (!isOpen) return undefined;

		const handleOutsideClick = event => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				handleClickAway();
			}
		};

		document.addEventListener("mousedown", handleOutsideClick);
		return () => document.removeEventListener("mousedown", handleOutsideClick);
	}, [isOpen]);

	const formatTicketDate = (updatedAt) => {
		if (!updatedAt) return "";

		try {
			const parsedDate = parseISO(updatedAt);
			return isSameDay(parsedDate, new Date())
				? format(parsedDate, "HH:mm")
				: format(parsedDate, "dd/MM/yyyy");
		} catch {
			return "";
		}
	};

	const handleSelectTicket = (ticket) => {
		setTabOpen(ticket.status);
		setCurrentTicket({
			id: ticket.id,
			uuid: ticket.uuid,
			code: `${ticket.id}-${Date.now()}`,
		});
		handleClickAway();
		history.push(`/tickets/${ticket.uuid}`);
	};

	const NotificationTicket = ({ ticket }) => {
		const unreadMessages = Number(ticket.unreadMessages || 0);
		const contactName = ticket.contact?.name || "Contato";
		const lastMessage = ticket.lastMessage || "Sem mensagem";
		const ticketDate = formatTicketDate(ticket.updatedAt);

		return (
			<button
				type="button"
				onClick={() => handleSelectTicket(ticket)}
				className="flex w-full cursor-pointer items-center gap-3 rounded-lg border-0 bg-farmazon-surface px-3 py-2 text-left transition-colors hover:bg-farmazon-hover"
			>
				<div className="relative h-10 w-10 shrink-0 overflow-hidden rounded-full bg-farmazon-surface-muted">
					{ticket.contact?.urlPicture ? (
						<img
							src={ticket.contact.urlPicture}
							alt={contactName}
							className="h-full w-full object-cover"
						/>
					) : (
						<div className="flex h-full w-full items-center justify-center text-farmazon-text-faint">
							<MdPerson size={24} />
						</div>
					)}
				</div>

				<div className="min-w-0 flex-1">
					<div className="flex items-center justify-between gap-2">
						<span className="truncate text-sm font-bold text-farmazon-text">
							{contactName}
						</span>
						<span className="shrink-0 text-xs text-farmazon-text-muted">
							{ticketDate}
						</span>
					</div>
					<div className="mt-0.5 truncate text-xs font-medium text-farmazon-text-muted">
						{lastMessage}
					</div>
				</div>

				{unreadMessages > 0 && (
					<span className="flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-red-500 px-1.5 text-[11px] font-bold text-white">
						{unreadMessages}
					</span>
				)}
			</button>
		);
	};

	const browserNotification = () => {
		const numbers = "⓿➊➋➌➍➎➏➐➑➒➓⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴";
		if (notifications.length > 0) {
			if (notifications.length < 21) {
				document.title = numbers.substring(notifications.length, notifications.length + 1) + " - " + (appName || "...");
			} else {
				document.title = "(" + notifications.length + ")" + (appName || "...");
			}
		} else {
			document.title = appName || "...";
		}
		return (
			<>
				<Favicon
					animated={true}
					url={defaultLogoFavicon}
					alertCount={notifications.length}
					iconSize={195}
				/>
			</>
		);
	};

	return (
		<div className="relative h-full w-full" ref={dropdownRef}>
			{browserNotification()}

			<button
				type="button"
				onClick={handleClick}
				aria-label="Abrir notificações"
				className="flex h-full w-full cursor-pointer items-center justify-center rounded-[10px] border-0 bg-transparent p-0 text-inherit outline-none transition-colors hover:bg-slate-50"
			>
				<span className="relative inline-flex">
					<MdChatBubbleOutline size={20} />
					{notifications.length > 0 && (
							<span className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center rounded-full border-2 border-farmazon-surface bg-red-500 px-1 text-[10px] font-bold leading-3 text-white">
							{notifications.length}
						</span>
					)}
				</span>
			</button>
			{isOpen && (
				<div className="absolute right-0 top-full z-[1300] mt-2 max-h-[350px] w-[320px] max-w-[calc(100vw-24px)] overflow-y-auto overflow-x-hidden rounded-xl border border-farmazon-border bg-farmazon-surface p-2 shadow-xl">
					{notifications.length === 0 ? (
						<div className="px-3 py-4 text-sm font-medium text-farmazon-text-muted">
							{i18n.t("notifications.noTickets")}
						</div>
					) : (
						<div className="flex flex-col gap-1">
							{notifications.map(ticket => (
								<NotificationTicket key={ticket.id} ticket={ticket} />
							))}
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default NotificationsPopOver;
